import React, { useContext } from 'react';
import { get } from 'lodash';

import AnswersDropdown from 'src/presentation/components/pages/shared/AnswersDropdown';
import { AnswerType } from 'src/presentation/components/pages/shared/hooks/useAnswersFilter';
import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import { campaignTypeToEndpointType } from 'src/presentation/components/pages/proactiveCommunications/constants';
import EndpointsDropdown from 'src/presentation/components/pages/proactiveCommunications/components/shared/EndpointsDropdown';
import FormContext from 'src/presentation/contexts/FormContext';
import LanguagesDropdown from 'src/presentation/components/pages/shared/LanguageDropdown';
import { Row } from 'src/presentation/components/forms/Layout';

const SmsCampaignContentEditor = () => {
  const { workingState } = useContext(FormContext);

  const answerLanguage = get(workingState, 'content.answerLanguage');

  return (
    <>
      <Row>
        <EndpointsDropdown
          data-aid="campaigns-endpoint-dropdown"
          attr="content.endpointId"
          label="Phone Number"
          placeholder="Select a phone number"
          description="The number used to send the SMS."
          endpointType={campaignTypeToEndpointType[CampaignType.SMS]}
        />
      </Row>

      <Row>
        <LanguagesDropdown attr="content.answerLanguage" />
      </Row>

      <Row>
        <AnswersDropdown
          answerType={AnswerType.MESSAGE}
          attr="content.answerId"
          language={answerLanguage}
          description="The Messaging Answer for your Campaign."
        />
      </Row>
    </>
  );
};

export default SmsCampaignContentEditor;
